module.exports = __webpack_public_path__ + "static/media/plano.176731c5.svg";